import React from 'react'
import styles from './MainButton.module.css'

interface MainButtonProps {
    message: string
    type: 'submit' | 'reset' | 'button'
    onClick: () => void
    disabled: boolean
    className?: string
}

const MainButton = ({ message, type, onClick, disabled, className }: MainButtonProps) => (
    <button type={type} className={`${styles.mainButton} ${className}`} onClick={onClick} disabled={disabled}>
        {message}
    </button>
)

export default MainButton
